export const formatTimeAgo = (dateString, t) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  
  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  
  if (diffInDays >= 1) {
    return `${diffInDays} ${t ? t("common.daysAgo") : "days ago"}`;
  } else if (diffInHours >= 1) {
    return `${diffInHours} ${t ? t("common.hoursAgo") : "hours ago"}`;
  } else {
    return `${diffInMinutes} ${t ? t("common.minutesAgo") : "minutes ago"}`;
  }
};
